// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1j7eZ","info":"PatientInfo_info__2KcOM"};